import { render, staticRenderFns } from "./AttributeDeleterDialog.vue?vue&type=template&id=2ac7cbaa&scoped=true"
import script from "./AttributeDeleterDialog.vue?vue&type=script&lang=ts"
export * from "./AttributeDeleterDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac7cbaa",
  null
  
)

export default component.exports